/**
 * Dynamically load html2canvas and jsPDF only when needed (PDF export, Save to Journal, etc.).
 * Avoids parsing these libraries on initial page load for faster time-to-interactive.
 */

const HTML2CANVAS_URL = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
const JSPDF_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';

let loadPromise = null;

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        document.head.appendChild(script);
    });
}

/**
 * Ensures html2canvas and jsPDF are loaded. Resolves when both are available on window.
 * Safe to call multiple times; only loads once.
 * @returns {Promise<void>}
 */
export function loadExportLibraries() {
    if (window.html2canvas && window.jspdf) {
        return Promise.resolve();
    }
    if (loadPromise) return loadPromise;
    loadPromise = Promise.all([
        loadScript(HTML2CANVAS_URL),
        loadScript(JSPDF_URL)
    ]);
    return loadPromise;
}
